if (typeof window.handleCardAddToCart !== 'function') {
  window.handleCardAddToCart = function(jsSecId, variantId, btnElement, productHandle) {
    const sectionEl = btnElement ? btnElement.closest('[id^="shopify-section-"], product-recommendations') : null;
    if (sectionEl && typeof sectionEl.addToCart === 'function') {
      sectionEl.addToCart(variantId, btnElement);
    } else if (jsSecId && typeof window['addToCart' + jsSecId] === 'function') {
      window['addToCart' + jsSecId](variantId, btnElement);
    } else if (typeof window.globalAddToCart === 'function') {
      window.globalAddToCart(variantId, btnElement);
    } else if (typeof window.addToCartDirect === 'function') {
      window.addToCartDirect(variantId, btnElement, productHandle);
    } else if (sectionEl && typeof sectionEl.openQuickView === 'function') {
      sectionEl.openQuickView(productHandle);
    } else if (jsSecId && typeof window['openSliderQuickView' + jsSecId] === 'function') {
      window['openSliderQuickView' + jsSecId](productHandle);
    } else if (typeof window.globalOpenQuickView === 'function') {
      window.globalOpenQuickView(productHandle);
    } else if (typeof window.openCollectionQuickView === 'function') {
      window.openCollectionQuickView(productHandle);
    } else {
      window.location.href = '/products/' + productHandle;
    }
  };
}

if (typeof window.handleCardQuickView !== 'function') {
  window.handleCardQuickView = function(jsSecId, productHandle, btnElement) {
    const sectionEl = btnElement ? btnElement.closest('[id^="shopify-section-"], product-recommendations') : null;
    if (sectionEl && typeof sectionEl.openQuickView === 'function') {
      sectionEl.openQuickView(productHandle);
    } else if (jsSecId && typeof window['openSliderQuickView' + jsSecId] === 'function') {
      window['openSliderQuickView' + jsSecId](productHandle);
    } else if (typeof window.globalOpenQuickView === 'function') {
      window.globalOpenQuickView(productHandle);
    } else if (typeof window.openCollectionQuickView === 'function') {
      window.openCollectionQuickView(productHandle);
    } else {
      window.location.href = '/products/' + productHandle;
    }
  };
}

if (typeof window.addToCartDirect !== 'function') {
  window.updateCartDrawerHTML = function(sections) {
    if (!sections || !sections['cart-drawer-section']) return;
    const existingInner = document.querySelector('theme-drawer#cart-drawer .cart-drawer__inner');
    if (existingInner) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer-section'], 'text/html');
      const newInner = doc.querySelector('.cart-drawer__inner');
      if (newInner) {
        existingInner.innerHTML = newInner.innerHTML;
        existingInner.className = newInner.className;
      }
    }
  };

  let updateBubbleTimer = null;
  window.updateCartCountBubbles = function() {
    if (updateBubbleTimer) clearTimeout(updateBubbleTimer);
    updateBubbleTimer = setTimeout(() => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const count = cart.item_count || 0;
          document.querySelectorAll('cart-icon').forEach(cartIcon => {
            if (typeof cartIcon.renderCartBubble === 'function') {
              cartIcon.renderCartBubble(count, false);
            } else {
              const countEl = cartIcon.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"]');
              const bubbleEl = cartIcon.querySelector('.cart-bubble, [ref="cartBubble"]');
              if (countEl) countEl.textContent = count < 100 ? String(count) : '';
              if (bubbleEl) {
                bubbleEl.classList.toggle('visually-hidden', count === 0);
                bubbleEl.classList.toggle('hidden', count === 0);
              }
              if (countEl) countEl.classList.toggle('hidden', count === 0);
              cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
            }
          });

          document.querySelectorAll('.cart-count-bubble, [data-cart-count], .header-actions__cart-count').forEach(el => {
            el.textContent = count;
            if (count === 0) {
              el.classList.add('hidden');
            } else {
              el.classList.remove('hidden');
            }
          });

          sessionStorage.setItem(
            'cart-count',
            JSON.stringify({
              value: String(count),
              timestamp: Date.now(),
            })
          );
        })
        .catch(() => {});
    }, 150);
  };

  window.openCartDrawer = function() {
    const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      const cartTrigger = document.querySelector('[aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"]');
      if (cartTrigger) cartTrigger.click();
    }
  };

  window.addToCartDirect = function(variantId, btnElement, productHandle) {
    if (!variantId || variantId === '') {
      if (productHandle && typeof window.openCollectionQuickView === 'function') {
        window.openCollectionQuickView(productHandle);
      }
      return;
    }

    const originalContent = btnElement.innerHTML;
    btnElement.disabled = true;
    btnElement.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: fc-spin 1s linear infinite;">
        <circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle>
        <path d="M12 2 a10 10 0 0 1 10 10" stroke-opacity="1"></path>
      </svg>
      ADDING...
    `;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId),
          quantity: 1
        }],
        sections: 'cart-drawer-section'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
      return response.json();
    })
    .then(data => {
      if (data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      window.updateCartDrawerHTML(data.sections);
      window.openCartDrawer();
      window.updateCartCountBubbles();

      btnElement.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B5637" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        ADDED!
      `;

      setTimeout(() => {
        btnElement.innerHTML = originalContent;
        btnElement.disabled = false;
      }, 1800);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      if (productHandle && typeof window.openCollectionQuickView === 'function') {
        window.openCollectionQuickView(productHandle);
      }
      btnElement.innerHTML = originalContent;
      btnElement.disabled = false;
    });
  };
}
